/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={6}
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.849 3.771 8.62 0l1.078 1.077-4.85 4.85L0 1.076 1.077 0 4.85 3.771Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowDown;
